<div class="Upgrade">
  <header>
    <h2 class="FormTitle">Interested in upgrading your subscription?</h2>
    <p class="FormDescription">This application is currently not part of your subscription. Submit this form to find more information.</p>
    <a class="Button Button--blue Button--back" routerLink='/'><span>Back</span></a>
  </header>
  <form [formGroup]="upgradeSubscriptionForm" (ngSubmit)="onSubmit($event)" id="user-form-template-186" action="https://web.cullen-international.com/api/forms/submit" method="POST">
    <input type="hidden" name="customer" value="ch000097152eArad">
    <input type="hidden" name="rurl" value="https://pages.cullen-international.com/Thank-you-page-Trial-Request">
    <input type="hidden" name="dialogid" value="1159">
    <input type="hidden" name="cke" value="1">
    <!-- insert service name here -->
    <input type="hidden" name="service" formControlName="service" >
    <div class="Alert Alert--basic" *ngIf="errorMessage">
      <mat-error [innerHtml]="errorMessage">{{errorMessage}}</mat-error>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- First Name -->
        <mat-form-field class="Cullen-material">
          <mat-label>First Name</mat-label>
          <input matInput type="text" id="firstName" formControlName="firstName" name="firstName" required >
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <!-- Last Name -->
        <mat-form-field class="Cullen-material">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" id="lastName" formControlName="lastName"  name="lastName" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- Company -->
        <mat-form-field class="Cullen-material">
          <mat-label>Company</mat-label>
          <input matInput type="text" id="company" formControlName="company" name="company" required >
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <!-- Email -->
        <mat-form-field class="Cullen-material">
          <mat-label>Email</mat-label>
          <input matInput type="email" id="email" formControlName="email" name="email" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="Button-container">
          <input class="Button Button--blue Button--send" type="submit" value="send"/>
          <input class="Button Button--blue Button--clear" type="submit" (click)="resetForm()" value="Clear" />
        </div>
      </div>
    </div>
  </form>
</div>